import React from 'react'

export const useScrollToTop = (trigger: any) => {
  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [trigger])
}

export const useScrollTo = (trigger: any, elementId: string) => {
  const element = React.useMemo(() => {
    if (typeof window !== 'undefined') {
      return document.getElementById(elementId)
    }

    return null
  }, [elementId])

  React.useEffect(() => {
    element?.scrollTo()
  }, [element, trigger])
}

type Props = {}

const ScrollToTop: React.FC<React.PropsWithChildren<Props>> = () => {
  // const { pathname } = useLocation();
  useScrollToTop('')
  return null
}

export default ScrollToTop
